import type {
  AnchorHTMLAttributes,
  MouseEvent,
  ReactElement,
  ReactNode
} from 'react';

type Props = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'children' | 'onClick'
> & {
  page: number;
  children: ReactNode;
  onClick?: (newPage: number) => void;
};

export function PaginationLink({
  page,
  children,
  onClick,
  ...otherProps
}: Props): ReactElement {
  const handleClick = (evt: MouseEvent<HTMLAnchorElement>) => {
    if (!onClick) return;

    evt.preventDefault();
    onClick(page);
  };

  return (
    <a {...otherProps} onClick={handleClick}>
      {children}
    </a>
  );
}
